import React, { useState, useEffect, Fragment } from 'react';
import LocationForm from './LocationForm';
import DataTable from 'react-data-table-component';

import { Alert } from 'react-bootstrap'
import { locationsService } from '../../../_services/locations.service';

export default function Locations() {

  const [total, setTotal] = useState(0);
  const [alert, setAlert] = useState("");
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState("");
  const [formType, setFormType] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [collection, setCollection] = useState([]);
  const [showLocationForm, setShowLocationForm] = useState(false);

  useEffect(() => {
    loadData(1);
  }, [])

  function loadData(page) {
    setLoading(true);

    locationsService.retrieve(page)
      .then(response => {
        setLoading(false);
        setTotal(response.meta.total)
        setCollection(response.data);
      });
  }

  const columns = [
    {
      name: 'ID',
      sort: false,
      selector: 'id',
      width: '50px'
    },
    {
      name: 'Name',
      sort: false,
      selector: 'name',
      grow: 2
    },
    {
      name: 'Address 1',
      sort: false,
      selector: 'address1',
      grow: 2
    },
    {
      name: 'Address 2',
      sort: false,
      selector: 'address2'
    },
    {
      name: 'City',
      sort: false,
      selector: 'city',
    },
    {
      name: 'State',
      sort: false,
      selector: 'state',
    },
    {
      name: 'Zip',
      sort: false,
      selector: 'zip',
    },
    {
      name: 'Phone Number',
      sort: false,
      selector: 'phoneNumber',
      grow: 2
    },
    {
      button: true,
      sort: false,
      cell: location => {
        return <button type="button" className="btn btn-primary"
          onClick={() => {
            setFormType("edit");
            setSelected(location);
            setShowAlert(false);
            setShowLocationForm(true)
          }}> Edit</button >
      }
    },
  ];

  return <div className="card axs-shadow mt-5">
    <div className="card-body">
      <div className="row border-bottom ">
        <div className="col">
          <h1 className="h3">Locations
            {formType === "add" && <span> Add</span>}
            {formType === "edit" && <span> Edit</span>}
          </h1>
        </div>
        {!formType &&
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
              onClick={() => {
                setFormType("add");
                setShowAlert(false);
                setShowLocationForm(true);
              }}>Add Location</button>
          </div>
        }
      </div>
      <div className="row">
        <div className="col">
          {(showLocationForm) ?
            <LocationForm
              type={formType}
              location={selected}
              close={() => {
                setSelected("");
                setFormType("");
                setShowLocationForm(false);
              }}
              success={(message) => {
                setShowAlert(true);
                setAlert(message);
                loadData(1);
              }}
            />
            :
            <Fragment>
              <Alert
                show={showAlert}
                variant="success"
                className="mt-3"
                dismissible
                onClose={() => setShowAlert(false)}
              >
                {alert}
              </Alert>
              <DataTable
                noHeader
                columns={columns}
                data={collection}
                progressPending={loading}
                onChangePage={page => { loadData(page) }}
                striped={true}
                pagination={true}
                paginationServer={true}
                paginationTotalRows={total}
                paginationRowsPerPageOptions={[15]}
                paginationPerPage={15}
                customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
              />
            </Fragment>
          }
        </div>
      </div>
    </div>
  </div >
}